import './LikelyCloses.scss'

import React, {Component} from 'react'
import { connect } from 'react-redux'
import { show as showModal } from 'redux-modal'
import ReactTooltip from 'react-tooltip'
import Table from 'common/views/atoms/Table/Table'
import ShowMore from 'react-show-more'
import moment from 'moment-timezone'
import LeadTypeBadges from 'broker/views/components/LeadTypeBadges'
import { selectIsTransitionBroker } from 'broker/selectors/auth'
import ReferralNoteModal from '../ReferralNoteModal'

import {
  fetchLikelyCloses, masqueradeAgent, searchLikelyCloses, fetchMarkets, fetchAgents
} from 'broker/redux/account'

import {
  getTimeframeFromFilterList,
  getQueriesFromFilterList,
  exportSearchFiltersForSegment,
  filtersWithValues
} from 'broker/util/helper'

import {
  newlineToBreak, labelFor
} from 'common/util/helper'

import {GenericLeadsDownloader} from "broker/util/downloader";
import DownloadModal from "broker/views/components/common/DownloadModal";
import {FilteredList} from "broker/views/components/common/Filter/FilteredList";
import _ from "lodash";

import {
  SHORT_ASSIGNMENT_AGENT_STATUS,
  SHORT_ASSIGNMENT_AGENT_STATUS_LISTING,
  SHORT_ASSIGNMENT_AGENT_STATUS_LEASE,
  AGENT_OFFER_STATUS_SELLING,
  AGENT_OFFER_STATUS_LISTING,
  AGENT_CONTRACT_STATUS,
  AGENT_CONTRACT_STATUS_LEASE,
  BUYER_TYPE,
  DISPLAY_PRICE,
  PRICE,
  LEAD_TYPE,
  REFERRAL_EXPORT_TIMEFRAME,
  LEAD_TYPE_OPTIONS
} from 'common/constants'

import { segmentEventTracker } from 'common/analytics'

import { selectAgentTerminationEnabled } from 'common/redux/selectors/auth'

import { AgentTerminated } from 'common/views/components/AgentTerminated'

const FILTER_KEYS = ['stage', 'market', 'client', 'price', 'agent', 'lead_type']
const FILTER_TYPE_OPTIONS = [
  {value: 'stage', label: 'Client Stage'},
  {value: 'market', label: 'Market'},
  {value: 'client', label: 'Client Category'},
  {value: 'price', label: 'Price Range'},
  {value: 'agent', label: 'Agent Name'},
  {value: 'timeframe', label: 'Time Period'},
  {value: 'market_vip', label: 'Market VIP'},
  {value: 'lead_type', label: 'Lead Type'},
]

const MARKET_VIP_FILTER = [{value: 'true', label: 'Only'}]

class LikelyCloses extends Component {

  constructor(props) {
    super(props)
    this.state = {
      excludeOnHold: false,
      filters: [{filter_type: 'timeframe', filter_value: 'month'}],
      activeFilters: [{filter_type: 'timeframe', filter_value: 'month'}],
      unusedFilters: FILTER_KEYS.filter(filter => filter.value !== 'timeframe'),
      dirty: false,
      options: {
        stage: [{value:"offers-made",label:"Made An Offer"}, {value:"contract",label:"Under Contract"}],
        client: BUYER_TYPE,
        price: PRICE,
        timeframe: REFERRAL_EXPORT_TIMEFRAME,
        market_vip: MARKET_VIP_FILTER,
        lead_type: LEAD_TYPE_OPTIONS,
        agent: [{value: "waiting-for-agents", label:"Waiting for agents..."}],
      }
    }
    this.downloader = new GenericLeadsDownloader()
    this.handleLikelyClosesExport = this.handleLikelyClosesExport.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.search = this.search.bind(this)
  }

  componentWillMount() {
    if (this.props.isTransitionBroker && !_.includes(FILTER_KEYS, 'market_vip')) {
      FILTER_KEYS.push('market_vip')
    }

    this.props.dispatch(fetchMarkets())
      .then(response => this.setState({
        options: {
          ...this.state.options,
          market: response.markets.map(market => {
            return {value: market.id, label: market.name}
          })
        }
      }))

    this.props.dispatch(fetchAgents())
      .then(response => {
        this.setState({
          options: {
            ...this.state.options,
            agent: response.agents.map(agent => {
              return {value: agent.id, label: agent.name}
            })},
          extraForSegment: {
            ...this.state.extraForSegment,
            agentUserHash: response.agents.map(agent => {
              return { id: agent.id, userHash: agent.user_hash }
            })
          }
        })
      })
  }

  toggleExcludeOnHold = (e) => {
    this.setState({excludeOnHold: e.target.checked, dirty: true})
  }

  addFilter = () => {
    this.setState({
      filters: [...this.state.filters].concat({filter_type: null, filter_value: null})
    })
    this.updateFilterType(this.state.filters.length, this.state.unusedFilters[0])
  }

  removeFilter = (idx) => {
    let filters = [...this.state.filters]

    filters.splice(idx, 1)
    let newActiveFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))

    this.setState({
      filters,
      unusedFilters,
      activeFilters: newActiveFilters,
      dirty: true
    })
  }

  updateFilterType = (idx, filter_type) => {
    let filters = [...this.state.filters]
    filters[idx] = {
      filter_type,
      filter_value: null
    }
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))
    this.setState({
      filters,
      unusedFilters
    })
  }

  updateFilterValue = (idx, filter_value, run_search = false) => {
    const search_callback = run_search ? this.handleFilter : null
    let filters = [...this.state.filters]
    filters[idx]['filter_value'] = filter_value
    let activeFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    this.setState({
      filters,
      activeFilters,
      dirty: true
    }, search_callback)
  }

  handleFilter = _.debounce(() => { this.search() } , 2000)

  handleSearch = _.debounce((searchTerm) => {
    this.setState({searchTerm})
    this.search(searchTerm)
  }, 800)

  search = (term) => {
    this.downloader.initializeSearchState()
    const activeFilters = getQueriesFromFilterList(this.state.activeFilters)
    if (term || !!this.state.searchTerm || activeFilters.length > 0) {
      term = term || this.state.searchTerm
      this.props.dispatch(searchLikelyCloses(getTimeframeFromFilterList(this.state.activeFilters), term, activeFilters, this.state.excludeOnHold, this.props.nav, true))
        .then(() => {
          this.setState({searching: false})
        }).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    } else {
      this.props.dispatch(fetchLikelyCloses(getTimeframeFromFilterList(this.state.activeFilters), this.state.excludeOnHold, this.props.nav, true))
        .then(() => {
          this.setState({searching: false})
        }).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    }
    const filteredFilters = filtersWithValues(this.state.filters)
    this.setState({searching: true, dirty: false, filters: filteredFilters})
  }

  handleEditClick = (item) => {
    this.props.dispatch(showModal('ReferralNoteModal', {
      item,
      onSave: () => {
        this.props.dispatch(fetchLikelyCloses(getTimeframeFromFilterList(this.state.activeFilters), this.state.excludeOnHold))
      }
    }))
  }

  handleLikelyClosesExport = () => {
    const baseSegmentProperties = {
      'downloaded_data': 'likely_closes'
    }

    const { activeFilters, extraForSegment } = this.state
    const agentFilter = activeFilters.find(filterEntry => filterEntry.filter_type === 'agent')
    const agentUserHashArray = extraForSegment ? extraForSegment.agentUserHash : []
    const foundAgent = agentFilter && agentUserHashArray.find(agent => agent.id === agentFilter.filter_value)
    const agentUserHash = agentFilter && foundAgent && foundAgent.userHash


    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      this.state.activeFilters,
      agentUserHash && { 'agent': agentUserHash }
    )

    segmentEventTracker('Data Downloaded',{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport
    })

    this.downloader.download({
      exportUrl: '/download/likely_closes',
      auth: this.props.auth, email: this.props.email, dispatch: this.props.dispatch, account: this.props.account,
      activeFilters: this.state.activeFilters, searchTerm: this.state.searchTerm,
      excludeOnHold: this.state.excludeOnHold})
  }

  handleClickForSegmentEvent = (item, eventName, otherSegmentProperties) => {
    const { activeFilters } = this.state

    const baseSegmentProperties = {
      'transaction_agent_user_hash': item.agent_user_hash,
      'transaction_likelihood_category': item.likelihood_category,
      'transaction_is_cashback': item.is_cashback,
      'transaction_external_id': item.external_transaction_id
    }

    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      activeFilters,
      { 'agent': item.agent_user_hash }
    )

    segmentEventTracker(eventName,{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport,
      ...otherSegmentProperties
    })
  }

  render() {
    const { props, state } = this
    const { dispatch, account } = props
    const { root } = props
    const { isLoading } = root
    const defaultNav = {next_page: null, prev_page: null, page_number: 1}
    const useNav = {...defaultNav, ...(_.get(props, 'account.nav', {}))}
    const timeFrameFilter = this.state.filters[0]
    const timeFrameOptions = this.state.options[timeFrameFilter.filter_type]

    function handleViewAgentClick(item) {
      dispatch(masqueradeAgent(item.agent_id))
        .then(response => {
          window.open(
            response.url,
            '_blank'
          )
        })
    }

    function getPage(forward) {
      const { activeFilters, searchTerm, excludeOnHold } = state
      let newNav = {
        'page_number': forward ? useNav.page_number + 1: useNav.page_number - 1,
        'page_key': forward ? useNav.next_page : useNav.prev_page
      }
      props.dispatch(searchLikelyCloses(getTimeframeFromFilterList(activeFilters), searchTerm, activeFilters, excludeOnHold, newNav, true))
    }

    function forward() {
      getPage(true)
    }

    function backward() {
      getPage(false)
    }


    const renderItem = (item) => {
      const agentTerminationEnabled = selectAgentTerminationEnabled(props)

      let status
      let subStatus
      let statusDisplay = SHORT_ASSIGNMENT_AGENT_STATUS
      let offersMadeDisplay = AGENT_OFFER_STATUS_SELLING
      let contractDisplay = AGENT_CONTRACT_STATUS
      if (item.client_category === 'seller') {
        statusDisplay = SHORT_ASSIGNMENT_AGENT_STATUS_LISTING
        offersMadeDisplay = AGENT_OFFER_STATUS_LISTING
      } else if (item.client_category === 'lease-other') {
        statusDisplay = SHORT_ASSIGNMENT_AGENT_STATUS_LEASE
        contractDisplay = AGENT_CONTRACT_STATUS_LEASE
      }
      status = labelFor(statusDisplay, item.status)

      if (item.status === 'offers-made') {
        subStatus = labelFor(offersMadeDisplay, item.agent_offer_status)
      } else if (item.status === 'contract') {
        subStatus = labelFor(contractDisplay, item.agent_contract_status)
      } else if (item.status === 'closed') {
        status = 'Closed'
        subStatus = 'Awaiting Payment'
      } else if (item.status === 'confirmed-closed') {
        status = 'Closed'
        subStatus = 'Paid'
      }

      return <tr key={ item.id }>
        <td>
          <div>
            <div className="LikelyCloses__assignment-name">
              <strong>{ item.override_name ? item.override_name : item.name }</strong>
            </div>
          </div>
          <div>{ item.email }</div>
          <div>{ item.phone }</div>
          <div>
            { labelFor(BUYER_TYPE, item.client_category) }: { item.max_budget ? item.standard_max_budget : labelFor(DISPLAY_PRICE, item.price_category) }
          </div>

          { item.broker_is_bla_enabled &&
            <div>Lead Source: {item.lead_source_name}</div>
          }
          <div>{ labelFor(LEAD_TYPE, item.likelihood_category) }</div>
          <div>{ item.market }  { item.zipcode }</div>
          <div>Assigned: { moment.utc(item.created_at).local().format("MM-DD-YY h:mm A") }</div>
        </td>
        <td>
          <div className="LikelyCloses__block">
            <a onClick={() => {
              this.handleClickForSegmentEvent(item, 'Sub-User Masqueraded', {
                'masqueraded_user_hash': item.agent_user_hash
              })

              handleViewAgentClick(item)
            }}>{ item.agent }</a>
          </div>

          <div className="LikelyCloses__block">
            <a href={"mailto:" + item.agent_email}>
                <span className="LikelyCloses__email fa fa-envelope"></span>
            </a>

            <span>{ item.agent_phone }</span>
          </div>

          { agentTerminationEnabled && item.agent_terminated_at &&
            <AgentTerminated teminatedAt={item.agent_terminated_at} />
          }
          <div>
            { item.agent_is_delinquent &&
              <span className="LikelyCloses__danger"><i className="fa fa-times-circle"/> Delinquent</span>
            }
          </div>
        </td>
        <td>
          { item.loan_officer ?
            <div className={item.loan_officer && item.settlement_officer ? "LikelyCloses__partner" : "LikelyCloses__partner--empty"}>
              <div className="LikelyCloses__block"><strong>{ item.loan_officer }</strong></div>
              <a className="LikelyCloses__email" href={"mailto:" + item.loan_officer_email}>
                 <span className="LikelyCloses__email fa fa-envelope"></span>
              </a>
              <span>{ item.loan_officer_phone }</span>
              <div className="LikelyCloses__ellipsis">Lender: { item.loan_broker }</div>
            </div> : (item.agent_close_lender_other && <div>Lender: { item.agent_close_lender_other }</div>)
          }

          { item.settlement_officer &&
            <div>
              <div className="LikelyCloses__block"><strong>{ item.settlement_officer }</strong></div>
              <a className="LikelyCloses__email" href={"mailto:" + item.settlement_officer_email}>
                 <span className="LikelyCloses__email fa fa-envelope"></span>
              </a>
              <span>{ item.settlement_officer_phone }</span>
              <div className="LikelyCloses__ellipsis">Closing Services: { item.settlement_broker }</div>
            </div>
          }
        </td>
        <td>
          <span className="pill pill-success LikelyCloses__block">{ status }</span>

          { item.agent_close_date &&
            <div className="LikelyCloses__block">
              <div className="LikelyCloses__projected-close-date">
                <span data-tip="This date has been set by the assigned agent as the closed date within Referral Manager">Projected Close Date:</span>
              </div>
              <div><i className="fa fa-calendar-check-o"/> { item.agent_close_date }</div>
            </div>
          }

          <div>Updated { item.agent_last_update_at }</div>
          <div>{ subStatus }</div>

          { item.agent_note &&
            <div className="LikelyCloses__note">
              <ShowMore lines={3} more='Show more' less='Show less' anchorClass=''>
                Agent Note: { newlineToBreak(item.agent_note) }
              </ShowMore>
            </div>
          }
        </td>
        <td>
          <LeadTypeBadges leadTags={item.lead_tags} />

          <div className="LikelyCloses__block">Transaction ID: {item.external_transaction_id}</div>

          {item.agent_is_holding &&
            <div className="LikelyCloses__danger">On Hold: {item.agent_hold_until}</div>
          }

          { (item.agent_property_address || item.agent_amount || item.agent_mls) &&
            <div>
              <div><strong>Property Details:</strong></div>
              { item.agent_property_address &&
                <div>{ item.agent_property_address }</div>
              }
              { item.agent_amount &&
                <div>${item.agent_amount}</div>
              }
              { item.agent_mls &&
                <div>MLS: {item.agent_mls}</div>
              }
            </div>
          }

          { item.transaction_in_review_at &&
            <div className="LikelyCloses__block LikelyCloses__in-review">
              In Review<br/>
              {item.transaction_in_review_at}
            </div>
          }

          { item.pdf_url &&
            <div className="LikelyCloses__agreement">
              <a href={item.pdf_url} target="_new">Referral agreement</a>
            </div>
          }

          <div className={item.broker_note ? "LikelyCloses__note LikelyCloses__note--broker" : "LikelyCloses__edit"}>
            { item.broker_note ? <div>{ newlineToBreak(item.broker_note) }<br/><br/></div> : null }
            <div>
              <a onClick={() => {
                this.handleEditClick(item)
                this.handleClickForSegmentEvent(item, 'Modal Shown', {
                  'modal_name': 'ReferralNoteModal | ' + (item.broker_note ? 'Edit' : 'Add')
                })
              }}>
                { !item.broker_note &&
                  <span className="fa fa-plus-circle"></span>
                }
              { item.broker_note ? " Edit" : " Add Note" }
              </a>
           </div>
          </div>
        </td>
      </tr>
    }

    function renderSection(items) {

      return (
        <div key={"likelyCloses"}>
          <Table>
            <thead>
              <tr>
                <th>Client</th>
                <th>Agent</th>
                <th>Partners</th>
                <th>Status</th>
                <th>Transaction Details</th>
              </tr>
            </thead>
            <tbody>
            { items.map(renderItem) }
            </tbody>
          </Table>
        </div>
      )
    }

    return (
      <div>
        <ReactTooltip/>
        <ReferralNoteModal {...this.props}/>
        <div className="LikelyCloses">
          <FilteredList
            checkboxOptions={{onHold: { onChange: this.toggleExcludeOnHold}}}
            dirty={this.state.dirty}
            filters={this.state.filters}
            filterOptions={this.state.options}
            isLoading={isLoading}
            maxLengthReached={Object.keys(this.state.options).length == (Object.keys(this.state.filters).length)}
            nav={this.props.account ? this.props.account.nav: null}
            timeFrameFilter={timeFrameFilter}
            timeFrameOptions={timeFrameOptions}
            typeOptionsConsts={FILTER_TYPE_OPTIONS}
            unusedFilters={this.state.unusedFilters}
            onAddFilter={this.addFilter}
            onApply={this.handleFilter}
            onExport={this.handleLikelyClosesExport}
            onPageForward={forward}
            onPageBackward={backward}
            onRemoveFilter={this.removeFilter}
            onSearch={this.handleSearch}
            onUpdateFilterType={this.updateFilterType}
            onUpdateFilterValue={this.updateFilterValue}
          >
            { props.account.search_results ? props.account.search_results.length !== 0 ? renderSection(props.account.search_results): null : <div className="LikelyCloses__loading pulse"/> }
          </FilteredList>


        </div>
        <DownloadModal {...this.props}/>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isTransitionBroker: selectIsTransitionBroker(state)
})

export default connect(mapStateToProps)(LikelyCloses)
